import { createSelector } from 'reselect';
import { notificationRulesActionTypes } from '../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const notificationRules =
  cachedRequestByIdReducer(notificationRulesActionTypes, 'byId');
export default notificationRules;

const getNotificationRulesState = state => state.notificationRules;

export const notificationRulesById = state =>
  getNotificationRulesState(state).byId;
export const getNotificationRuleById = (state, id) =>
  notificationRulesById(state)[id];

export const getNotificationRules = createSelector(
  getNotificationRulesState,
  (ruleState) => Object.values(ruleState.byId)
);


// WEBPACK FOOTER //
// src/reducers/notificationRules.js